import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({
  product,
  variant = 'default',
  showDiscount = true,
  showShipping = true,
  className = '',
  style = {}
}) => {
  // Traducción eliminada, todo texto está en español.
  const translatedTitle = product.title; // Hardcoded title in Spanish
  const translatedDescription = product.description; // Hardcoded description in Spanish

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price);
  };

  const price = typeof product.price === 'number' ? product.price : Number(product.price) || 0;
  const oldPrice = product.old_price && typeof product.old_price === 'number'
    ? product.old_price
    : (product.old_price ? Number(product.old_price) : 0);

  const discount = oldPrice > 0
    ? Math.round(((oldPrice - price) / oldPrice) * 100)
    : 0;

  // Stock status logic
  const getStockStatus = () => {
    const stock = product.stock_qty || product.stock || product.quantity || 0;
    console.log('ProductCard Debug:', product.title, 'stock_qty:', product.stock_qty, 'stock:', product.stock, 'calculated stock:', stock);
    if (stock === 0 || stock === '0') {
      return { status: 'out', label: 'Sin stock', color: '#dc2626', bgColor: '#fef2f2' };
    } else if (stock < 20) {
      return { status: 'low', label: `${stock} restantes`, color: '#ea580c', bgColor: '#fff7ed' };
    } else {
      return { status: 'available', label: 'En stock', color: '#16a34a', bgColor: '#f0fdf4' };
    }
  };

  const stockInfo = getStockStatus();

  // Card style is now handled by Tailwind classes for height/width/flex
  const cardStyles = {
    default: {
      minHeight: '360px',
      maxWidth: '280px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
    compact: {
      minHeight: '300px',
      maxWidth: '240px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
    grid: {
      minHeight: '340px',
      maxWidth: '260px',
      boxShadow: '0 3px 14px rgba(0,0,0,0.09)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
    mini: {
      minHeight: '120px',
      maxWidth: '180px',
      boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
  };

  const imageStyles = {
    default: {
      width: '100%',
      height: '200px',
      objectFit: 'contain',
      backgroundColor: 'white',
    },
    compact: {
      width: '100%',
      height: '160px',
      objectFit: 'contain',
      backgroundColor: 'white',
      padding: '8px',
    },
    grid: {
      width: '100%',
      height: '180px',
      objectFit: 'contain',
      backgroundColor: 'white',
      padding: '8px',
    },
    mini: {
      width: '100%',
      height: '80px',
      objectFit: 'contain',
      backgroundColor: 'white',
      padding: '6px',
    }
  };
  const generateProductURL = () => {
    const baseURL = `/detail/${product.slug}`;
    
    // Check if product has colors and sizes
    if (product.colors && product.colors.length > 0 && product.sizes && product.sizes.length > 0) {
      const firstColor = product.colors[0].name;
      const firstSize = product.sizes[0].name;
      return `${baseURL}/${encodeURIComponent(firstColor)}/${encodeURIComponent(firstSize)}/`;
    } else if (product.colors && product.colors.length > 0) {
      const firstColor = product.colors[0].name;
      return `${baseURL}/${encodeURIComponent(firstColor)}/No%20Size/`;
    } else if (product.sizes && product.sizes.length > 0) {
      const firstSize = product.sizes[0].name;
      return `${baseURL}/No%20Color/${encodeURIComponent(firstSize)}/`;
    }
    
    return baseURL;
  };

  return (
    <div>
      <Link
        to={generateProductURL()}
        style={{
          color: 'inherit',
          textDecoration: 'none',
          display: 'block',
          height: '100%',
          ...style
        }}
        className={className}
      >
        <div 
          style={{
            ...cardStyles[variant],
            ...style,
            backgroundColor: 'white',
          }}
          className={`product-card-${variant}`}
          onMouseEnter={(e) => {
            // Change text color to blue for title and description
            const titleElement = e.currentTarget.querySelector('h3');
            const descriptionElement = e.currentTarget.querySelector('p');
            if (titleElement) {
              titleElement.style.color = '#3483fa';
            }
            if (descriptionElement) {
              descriptionElement.style.color = '#3483fa';
            }
          }}
          onMouseLeave={(e) => {
            // Reset product title and description color
            const titleElement = e.currentTarget.querySelector('h3');
            const descriptionElement = e.currentTarget.querySelector('p');
            if (titleElement) {
              titleElement.style.color = '#111827';
            }
            if (descriptionElement) {
              descriptionElement.style.color = '#6b7280';
            }
          }}
        >
          <div style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '260px',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <img
              src={product.image || "/placeholder.svg"}
              alt={translatedTitle}
              style={{
                ...imageStyles[variant],
                objectFit: 'contain',
                width: '100%',
                margin: '0 auto',
              }}
            />
            {showDiscount && discount > 0 && (
              <div style={{
                position: 'absolute',
                top: '6px',
                left: '6px',
                background: '#00a650',
                color: 'white',
                padding: '3px 6px',
                borderRadius: '4px',
                fontSize: '10px',
                fontWeight: '600',
                zIndex: 2,
                maxWidth: '45px',
                textAlign: 'center',
                lineHeight: '1.2',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
              }}>
                -{discount}%
              </div>
            )}
            {/* Stock Status Indicator */}
            <div style={{
              position: 'absolute',
              top: showDiscount && discount > 0 ? '32px' : '6px',
              left: '6px',
              background: stockInfo.bgColor,
              color: stockInfo.color,
              padding: '3px 6px',
              borderRadius: '10px',
              fontSize: '9px',
              fontWeight: '600',
              zIndex: 2,
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              animation: stockInfo.status === 'available' ? 'stockPulse 2s ease-in-out infinite' :
                       stockInfo.status === 'low' ? 'stockGlow 1.5s ease-in-out infinite alternate' :
                       'none',
              border: stockInfo.status === 'low' ? '1px solid rgba(234, 88, 12, 0.3)' : 'none',
            }}>
              <div style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: stockInfo.color,
                animation: stockInfo.status === 'available' ? 'dotPulse 2s ease-in-out infinite' : 'none',
              }}></div>
              {stockInfo.label}
            </div>
          </div>
          
          <div className="product-content flex flex-col flex-1 justify-between gap-2 p-2" style={{padding: variant === 'compact' ? '8px' : variant === 'mini' ? '4px' : '10px'}}>
            <h3 style={{
              fontSize: variant === 'compact' ? '16px' : variant === 'mini' ? '12px' : '20px',
              lineHeight: '1.1',
              color: '#111827',
              margin: '0 0 2px 0',
              fontWeight: '600',
              height: variant === 'compact' ? '30px' : variant === 'mini' ? '18px' : '36px',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              transition: 'color 0.2s ease',
              letterSpacing: '-0.025em',
            }}>
              {translatedTitle}
            </h3>
            
            {/* Product description under title */}
            <div style={{ marginTop: '0px' }}>
              {translatedDescription && translatedDescription.length > 0 && (
                <p style={{
                  fontSize: variant === 'mini' ? '8px' : '12px',
                  color: '#6b7280',
                  lineHeight: '1.2',
                  margin: '0 0 1px 0',
                  height: variant === 'compact' ? '12px' : variant === 'mini' ? '8px' : '14px',
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  transition: 'color 0.2s ease',
                }}>
                  {translatedDescription}
                </p>
              )}
              {oldPrice > 0 && (
                <div style={{
                  fontSize: variant === 'compact' ? '10px' : variant === 'mini' ? '8px' : '12px',
                  color: '#999',
                  textDecoration: 'line-through',
                  marginBottom: '2px'
                }}>
                  {formatPrice(oldPrice)}
                </div>
              )}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                marginBottom: '0px',
                marginTop: translatedDescription && translatedDescription.length > 0 ? '1px' : '4px',
              }}>
                <span className="price" style={{
                  fontSize: variant === 'compact' ? '16px' : variant === 'mini' ? '12px' : '20px',
                  fontWeight: '600',
                  color: '#1a1a1a',
                }}>
                  {formatPrice(price)}
                </span>
                {showDiscount && discount > 0 && (
                  <span style={{
                    fontSize: variant === 'compact' ? '9px' : variant === 'mini' ? '8px' : '10px',
                    color: '#00a650',
                    backgroundColor: '#f0f9f0',
                    padding: '1px 4px',
                    borderRadius: '3px',
                    fontWeight: '500',
                  }}>
                    {discount}% OFF
                  </span>
                )}
              </div>
              
              {showShipping && (product.shipping_ammount === 0 || product.shipping_ammount === '0') && (
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: variant === 'compact' ? '10px' : variant === 'mini' ? '8px' : '12px',
                  color: '#00a650',
                  fontWeight: '600',
                  marginTop: '4px',
                  background: '#f0fdf4',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  border: '1px solid #dcfce7',
                }}>
                  <span>🚚</span>
                  Envío gratis
                </div>
              )}
              

            </div>
          </div>
        </div>
      </Link>

      <style>
        {`
          /* Mobile Responsiveness */
          @media (max-width: 768px) {
            .product-card-default h3 {
              font-size: 14px !important;
              height: 40px !important;
            }
            
            .product-card-compact h3 {
              font-size: 13px !important;
              height: 36px !important;
            }
            
            .product-card-grid h3 {
              font-size: 15px !important;
              height: 44px !important;
            }
          }
          
          @media (max-width: 480px) {
            .product-card-default h3 {
              font-size: 13px !important;
              height: 36px !important;
            }
            
            .product-card-compact h3 {
              font-size: 12px !important;
              height: 32px !important;
            }
            
            .product-card-grid h3 {
              font-size: 14px !important;
              height: 40px !important;
            }
          }
        `}
      </style>
      
      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .product-card-default,
          .product-card-compact,
          .product-card-grid {
            height: auto !important;
            min-height: 280px !important;
            max-width: 100% !important;
            margin: 0 auto !important;
            border-radius: 12px !important;
            width: 100% !important;
          }
          
          .product-card-default img,
          .product-card-compact img,
          .product-card-grid img {
            height: 120px !important;
            padding: 8px !important;
            object-fit: contain !important;
          }
          
          .product-card-default .product-content,
          .product-card-compact .product-content,
          .product-card-grid .product-content {
            padding: 10px !important;
            min-height: 120px !important;
            display: flex !important;
            flex-direction: column !important;
            justify-content: flex-start !important;
            gap: 4px !important;
          }
          
          .product-card-default h3,
          .product-card-compact h3,
          .product-card-grid h3 {
            font-size: 12px !important;
            height: auto !important;
            min-height: 28px !important;
            max-height: 32px !important;
            line-height: 1.2 !important;
            margin-bottom: 4px !important;
            -webkit-line-clamp: 2 !important;
          }
          
          .product-card-default p,
          .product-card-compact p,
          .product-card-grid p {
            font-size: 10px !important;
            height: auto !important;
            min-height: 10px !important;
            margin-bottom: 2px !important;
            display: none !important;
          }
          
          .product-card-default .price,
          .product-card-compact .price,
          .product-card-grid .price {
            font-size: 16px !important;
            font-weight: 700 !important;
            display: block !important;
            margin-top: 4px !important;
            color: #1a1a1a !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
        }
        
        @media (max-width: 480px) {
          .product-card-default,
          .product-card-compact,
          .product-card-grid {
            min-height: 260px !important;
          }
          
          .product-card-default img,
          .product-card-compact img,
          .product-card-grid img {
            height: 100px !important;
          }
          
          .product-card-default .product-content,
          .product-card-compact .product-content,
          .product-card-grid .product-content {
            padding: 8px !important;
            min-height: 110px !important;
          }
          
          .product-card-default h3,
          .product-card-compact h3,
          .product-card-grid h3 {
            font-size: 11px !important;
            min-height: 26px !important;
            max-height: 28px !important;
          }
          
          .product-card-default .price,
          .product-card-compact .price,
          .product-card-grid .price {
            font-size: 15px !important;
          }
        }
        
        /* Stock Status Animations */
        @keyframes stockPulse {
          0%, 100% { 
            transform: scale(1); 
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }
          50% { 
            transform: scale(1.05); 
            box-shadow: 0 2px 8px rgba(22, 163, 74, 0.2);
          }
        }
        
        @keyframes dotPulse {
          0%, 100% { 
            opacity: 1; 
            transform: scale(1);
          }
          50% { 
            opacity: 0.7; 
            transform: scale(1.2);
          }
        }
        
        @keyframes stockGlow {
          0% { 
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 0 0 rgba(234, 88, 12, 0.3);
          }
          100% { 
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 0 2px rgba(234, 88, 12, 0.3);
          }
        }
      `}</style>
    </div>
  );
};

export default ProductCard;

